import { redirect } from "react-router-dom";

export function action() {
    localStorage.removeItem('jwt');
    return redirect('/');
}